import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import Section from '../../layout/Section';
import XButton from '../../inputs/XButton';
import P from '../../typography/P';
import useComponentPadding from '../../hooks/useComponentPadding';
import useComponentMargin from '../../hooks/useComponentMargin';
import useDismissal from './useDismissal';
const AlertBar = ({ children, type = 'brand', isDismissable = false, autoDismiss = false, autoDismissDelay = 'medium', onDismiss, styles }) => {
    const [isOpen, handleDismiss] = useDismissal(autoDismiss, autoDismissDelay, onDismiss);
    const { colors, typography } = useTheme();
    const padding = useComponentPadding({ padding: 'regular' });
    const xIconMargin = useComponentMargin({ marginRight: 'regular' });
    const mergedStyles = useMemo(() => ({
        position: 'relative',
        backgroundColor: type === 'brand' ? colors.brand.secondary.alpha : colors.status[type].alpha,
        textTransform: 'uppercase',
        ...typography.eyebrow,
        ...(typeof children === 'string' ? padding : {}),
        ...styles
    }), [type, styles, colors, padding, typography, children]);
    const xIconStyles = useMemo(() => ({
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translate(0, -50%)',
        ...xIconMargin
    }), [xIconMargin]);
    return isOpen ? (React.createElement(Section, { role: "wrapper", styles: mergedStyles },
        typeof children === 'string' ? (React.createElement(P, { size: "small", inverted: type === 'fail', noDefaultMargin: true, centered: true, strong: true }, children)) : (children),
        isDismissable && (React.createElement(XButton, { alt: "dismiss", size: "small", onClick: handleDismiss, styles: xIconStyles })))) : null;
};
export default AlertBar;
//# sourceMappingURL=index.js.map